import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Evaluations from "src/components/panel/evaluations/Evaluations";

const EvaluationsView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("evaluations_list_tab")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb
          title={t("evaluations_list_title")}
          subtitle={t("evaluations_list_subtitle")}
        />
        <Evaluations />
      </Sidebar>
    </>
  );
};

export default EvaluationsView;
